var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4328_1620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.3998C23.496 2.3998 29.6 8.5038 29.6 15.9998C29.6 23.4958 23.496 29.5998 16 29.5998C8.50405 29.5998 2.40005 23.4958 2.40005 15.9998C2.40005 8.5038 8.50405 2.3998 16 2.3998ZM16 0.799805C7.60805 0.799805 0.800049 7.6078 0.800049 15.9998C0.800049 24.3918 7.60805 31.1998 16 31.1998C24.392 31.1998 31.2 24.3918 31.2 15.9998C31.2 7.6078 24.392 0.799805 16 0.799805Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 10.0319C16.8174 10.0319 17.5839 9.26542 17.5839 8.31991C17.5839 7.3744 16.8174 6.60791 15.8719 6.60791C14.9264 6.60791 14.1599 7.3744 14.1599 8.31991C14.1599 9.26542 14.9264 10.0319 15.8719 10.0319Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 25.9357C15.2079 25.9357 14.6719 25.3997 14.6719 24.7357V13.5037C14.6719 12.8397 15.2079 12.3037 15.8719 12.3037C16.5359 12.3037 17.0719 12.8397 17.0719 13.5037V24.7357C17.0719 25.3997 16.5359 25.9357 15.8719 25.9357Z",
    fill: "#353EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4328_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.b0c14aee85ec60d4d111544968a08a6b.svg";
export { ForwardRef as ReactComponent };